(function () {
  'use strict';

  var GROUPS = [
    { name: 'Cancer', blurb: 'Inherited cancer risk',
      keys: ['Breast cancer', 'Colorectal cancer', 'Other cancer'],
      rows: ['Breast cancer', 'Ovarian cancer', 'Prostate and pancreatic cancer', 'Colorectal cancer', 'Other rare cancer syndromes'] },
    { name: 'Heart', slug: 'cardiac', blurb: 'Heart & circulatory risk',
      keys: ['Cardiomyopathy', 'Heart rhythm disorders', 'Other heart and circulation'],
      rows: ['Cholesterol', 'Cardiomyopathy', 'Heart rhythm disorders', 'Other heart and circulation'] },
    { name: 'Additional', slug: 'other', blurb: 'Other actionable risk', keys: ['Blood and immune health', 'Brain, nerve and muscle health', 'Liver and kidney health', 'Hormones and metabolism', 'Diabetes', 'Skin, bones and connective tissue'] }
  ];

  function init() {
    var track = document.querySelector('[data-us-catcard]:not([data-us-catcard-wired])');
    var P = window.US_PANEL;
    if (!track || !P || !P.categories || !P.categories.length) return;
    track.setAttribute('data-us-catcard-wired', '');
    var ICONS = window.US_CATEGORY_ICONS;
    var link = track.getAttribute('data-link');
    var ctaLabel = track.getAttribute('data-cta-label') || 'See what we screen';
    var testPhoto = track.getAttribute('data-test-photo');

    function icon(name) {
      return ICONS && ICONS.build ? ICONS.build(name, 'us-catcard__icon') : null;
    }

    function findCat(name) {
      for (var i = 0; i < P.categories.length; i++) {
        if (P.categories[i].name === name) return P.categories[i];
      }
      return null;
    }

    var soonAnchor = track.firstElementChild;

    GROUPS.forEach(function (group) {
      var cats = group.keys.map(findCat).filter(Boolean);
      if (!cats.length) return;
      var total = cats.reduce(function (sum, c) { return sum + (c.count || 0); }, 0);

      var card = document.createElement(link ? 'a' : 'div');
      card.className = 'us-catcard__card';
      if (link) card.href = link;

      var mediaBox = document.createElement('div');
      mediaBox.className = 'us-catcard__mediabox';
      var media = document.createElement('div');
      var slug = group.slug || group.name.toLowerCase();
      media.className = 'us-catcard__media us-catcard__media--' + slug + ' no-empty';
      var photo = track.getAttribute('data-photo-' + slug) || testPhoto;
      if (photo) media.style.setProperty('--_photo', 'url(' + photo + ')');
      mediaBox.appendChild(media);
      card.appendChild(mediaBox);

      var panel = document.createElement('div');
      panel.className = 'us-catcard__panel';

      var header = document.createElement('div');
      header.className = 'us-catcard__panel-head';
      var title = document.createElement('h3');
      title.className = 'us-catcard__title';
      title.textContent = group.name;
      var count = document.createElement('p');
      count.className = 'us-catcard__count';
      count.textContent = total + '+ genes';
      header.appendChild(title);
      header.appendChild(count);
      panel.appendChild(header);

      var list = document.createElement('ul');
      list.className = 'us-catcard__list';
      (group.rows || cats.map(function (c) { return c.name; })).forEach(function (name) {
        var li = document.createElement('li');
        li.className = 'us-catcard__item';
        var tile = document.createElement('span');
        tile.className = 'us-catcard__tile';
        var ic = icon(name);
        if (ic) tile.appendChild(ic);
        var label = document.createElement('span');
        label.className = 'us-catcard__label';
        label.textContent = name;
        li.appendChild(tile);
        li.appendChild(label);
        list.appendChild(li);
      });
      panel.appendChild(list);

      if (link) {
        var cta = document.createElement('span');
        cta.className = 'us-catcard__cta';
        cta.textContent = ctaLabel + ' →';
        panel.appendChild(cta);
      }

      card.appendChild(panel);
      if (soonAnchor) track.insertBefore(card, soonAnchor);
      else track.appendChild(card);
    });

    var root = track.closest('.us-catcard');
    var prevBtn = root && root.querySelector('[data-us-catcard-prev]');
    var nextBtn = root && root.querySelector('[data-us-catcard-next]');
    if (!prevBtn || !nextBtn) return;

    function step() {
      var cards = track.querySelectorAll('.us-catcard__card');
      if (cards.length >= 2) return cards[1].offsetLeft - cards[0].offsetLeft;
      return cards.length ? cards[0].getBoundingClientRect().width + 24 : 320;
    }
    prevBtn.addEventListener('click', function () { track.scrollBy({ left: -step(), behavior: 'smooth' }); });
    nextBtn.addEventListener('click', function () { track.scrollBy({ left: step(), behavior: 'smooth' }); });

    function updateArrows() {
      var max = track.scrollWidth - track.clientWidth - 2;
      prevBtn.disabled = track.scrollLeft <= 0;
      nextBtn.disabled = track.scrollLeft >= max;
    }
    track.addEventListener('scroll', updateArrows, { passive: true });
    window.addEventListener('resize', updateArrows);
    updateArrows();
  }

  if (document.readyState === 'complete') init();
  else document.addEventListener('DOMContentLoaded', init);
  document.addEventListener('shopify:section:load', init);
})();
